export const SESSION_STORAGE_KEYS = {
	HAS_FETCHED_CACHE: (appid: string) => "HAS_FETCHED_CACHE-" + appid,
	CREATED_APPLICATION_ID: "CREATED_APPLICATION_ID",
	// URL to return to when FTN sign-in fails/cancels, so the auth-error page
	// can send the applicant back to the summary to try again.
	FTN_RETURN_URL: "FTN_RETURN_URL",
};
